/* audioBus — page-level audio focus coordinator (iter100).
   Only ONE memorial audio source may play at a time (ambient music,
   Life Journey video, Life Story narration, Voice Memories, or any
   future player). The most recent source to start playing claims
   focus and every other registered source is paused immediately.
   Nothing is ever auto-resumed — the visitor stays in control. */

const sources = new Map(); // id -> pause()

export function registerAudioSource(id, pauseFn) {
  sources.set(id, pauseFn);
  return () => { sources.delete(id); };
}

export function claimAudioFocus(id) {
  for (const [otherId, pause] of sources) {
    if (otherId !== id) {
      try { pause(); } catch { /* noop */ }
    }
  }
}
